import { HANDLE_MODAL, HANDLE_SNACKBAR } from "redux/TypeConstant";

const ModalPassReducer = (
  state = {
    modalPass: {
      show: false,
    
    },
  },
  action
) => { 
  switch (action.type) {
    case HANDLE_MODAL:
      return {
        ...state,
        modalPass: {
          show: action.show,
         
        },
      };
    default:
      return state;
  }
};

export default ModalPassReducer;
